import request from '@/utils/request'

export function create(data) {

  return request({
    url: '/baseDataYEYSGTZBZ/create',
    method: 'POST',
    data})
}

   

export function createBatch(data) {

  return request({
    url: '/baseDataYEYSGTZBZ/create/batch',
    method: 'POST',
    data})
}

   

export function deleteById(data) {

  return request({
    url: '/baseDataYEYSGTZBZ/deleteById',
    method: 'POST',
    data})
}

   

export function deleteByIds(data) {

  return request({
    url: '/baseDataYEYSGTZBZ/deleteByIds',
    method: 'POST',
    data})
}

   

export function getById(params) {

  return request({
    url: '/baseDataYEYSGTZBZ/getById',
    method: 'GET',
    params})
}

   

export function getByIds(params) {

  return request({
    url: '/baseDataYEYSGTZBZ/getByIds',
    method: 'GET',
    params})
}

   

export function list(params) {

  return request({
    url: '/baseDataYEYSGTZBZ/list',
    method: 'GET',
    params})
}

   

export function update(data) {

  return request({
    url: '/baseDataYEYSGTZBZ/update',
    method: 'POST',
    data})
}

   

export function updateBatch(data) {

  return request({
    url: '/baseDataYEYSGTZBZ/update/batch',
    method: 'POST',
    data})
}

   